export default (permiso) => {

    if (permiso === -1) {
        return true;
    }

    let valid = false;
    const user = JSON.parse(localStorage.getItem('user'));

    //if (session && session.logueado === true) {
    if (true) {
        if (Array.isArray(permiso)) {
            var permisosContenidos = user.permisos.filter(
                (permisoUsuario) => {
                    return permiso.includes(permisoUsuario);
                });
            if (permisosContenidos.length > 0) {
                valid = true;
            }
        } else {
            if (user.permisos) {
                valid = user.permisos.includes(permiso);
            }
        }
    }
    return valid;
};
